// extracted by mini-css-extract-plugin
module.exports = {"special_offers":"SpecialOffers_special_offers__9etUF","border_color":"SpecialOffers_border_color__bboXl"};